module.exports = __webpack_public_path__ + "documents/VHDP_AWS_539_CL_(03.13.2020)-(Wireless)_(FINAL)_PDF.pdf";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/pages/termspage/pdf/VHDP_AWS_539_CL_(03.13.2020)-(Wireless)_(FINAL)_PDF.pdf
// module id = 3533
// module chunks = 0